<template>
  <div class="page">
    <header-title title="BJHC Porducts Delivery Tracking">
      <template #left>
        <span style="padding-left: 15px">Kanban Board as Manufacturer</span>
      </template>
    </header-title>
    <div class="s-filter-box" v-if="!showDetailBox">
      <a-form layout="inline" :model="search">
        <a-form-item>
          <a-select v-model:value="search.type" class="sel" @change="getCont">
            <a-select-option
              v-for="item in types"
              :value="item.value"
              :key="item.name"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item>
          <a-button type="primary" @click="getCont">
            <template #icon><SearchOutlined /></template>
            Find
          </a-button>
        </a-form-item>
      </a-form>
    </div>
    <div class="page-content row" :class="{ 'is-show-detail': showDetailBox }">
      <div
        class="col card-box"
        :style="setCardBoxSty(filterData.length)"
        v-for="(item, index) in filterData"
        :key="item.spoStatusCode"
      >
        <div
          class="in-card"
          :style="{ color: item.statusColour }"
          @click="showDetail(item, index + 1)"
        >
          <div class="value">{{ item.count }}</div>
          <div class="name">{{ item.statusNameEn }}</div>
          <div class="zh-name">{{ item.spoStatus }}</div>
          <div class="d-icon">
            <i class="iconfont" :class="item.statusIcon"></i>
          </div>
        </div>
      </div>
    </div>
    <detail
      v-if="curDetail && showDetailBox"
      :cur-detail="curDetail"
      @closeShowDetailBox="showDetailBox = false"
    ></detail>
  </div>
</template>
<script setup>
  import { ref, reactive, onUnmounted, computed } from 'vue'
  import HeaderTitle from '@/layout/header-title'
  import { SearchOutlined } from '@ant-design/icons-vue'
  import { logisticURL } from '@/config'
  import dayjs from 'dayjs'
  import request from '@/utils/request'
  import Detail from './detail.vue'
  import { message } from 'ant-design-vue'
  const curDetail = ref(null)
  const search = reactive({
    type: 0,
  })

  const types = [
    { name: 'All(全部)', value: '3' },
    { name: 'China(国内)', value: 0 },
    { name: 'Abroad(国外)', value: 1 },
  ]
  const pageCounts = ref([])
  const createOnRange = ref([])
  const showDetailBox = ref(false)
  const timer = ref(null)
  const getCont = (hasLoading = true) => {
    let loading
    if (hasLoading) {
      loading = message.loading('Loading……')
    }
    let reqData = { pageNo: 1 }
    if (createOnRange.value.length) {
      reqData.createOnState = dayjs(createOnRange.value[0]).valueOf()
      reqData.createOnEnd = dayjs(createOnRange.value[1]).valueOf()
    }
    reqData.toCountry = search.type * 1
    return new Promise((resolve) => {
      request({
        baseURL: logisticURL,
        method: 'post',
        url: '/api/v1/deliverySpo/getCount',
        data: reqData,
      })
        .then((res) => {
          pageCounts.value = res.data

          resolve(res.data)
        })
        .finally(() => {
          loading()
          clearTimeout(timer.value)
          timer.value = setTimeout(() => getCont(false), 60000)
        })
    })
  }
  onUnmounted(() => {
    clearTimeout(timer.value)
  })
  getCont()

  const filterData = computed(() => {
    if (showDetailBox.value) {
      return pageCounts.value.filter(
        (item) => curDetail.value.spoStatusCode === item.spoStatusCode
      )
    } else {
      return pageCounts.value
    }
  })
  const showDetail = (item) => {
    // this.inTransitquery = {}
    showDetailBox.value = true
    curDetail.value = item
    // this.pageConfig.pageIndex = 1
    // this.tableList = []
    // this.pageConfig.totalCount = 0
    // this.tableHead =
    //   item.spoStatusCode === 'DELIVER_GOODS' ||
    //   item.spoStatusCode === 'PROCESSING'
    //     ? inTransitHead
    //     : arrivedHead
    // // 设置滚动条到初初始位置
    // const detailTableElement = document.querySelector('#detail-table-box')
    // detailTableElement.scrollLeft = 0
    // detailTableElement.scrollTop = 0
  }
  const setCardBoxSty = (length) => {
    if (length < 5) {
      return { flex: `0 0 ${length / 2}%` }
    } else if (length === 6) {
      return { flex: '0 0 33.33333%' }
    } else {
      return { flex: '0 0 20%' }
    }
  }
</script>

<style lang="less" scoped>
  @import './css.less';
</style>
